export default __webpack_public_path__ + "static/media/icons-log-out.d9b69710.svg";